var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonComponent',_vm._g({staticClass:"shop-contextual-images-input",class:{
    'shop-contextual-images-input--empty': !this.value.length,
    'shop-contextual-images-input--invalid': !_vm.isValidContextualImages,
  },attrs:{"icon":['fal', _vm.isValidContextualImages ? 'images' : 'exclamation-triangle'],"label":_vm.label}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }